import { useEffect, useRef, useState } from "react";
import { apiRequest } from "../../api/client";

const SearchBar = ({setResults, setMsg, setIsSortedYear, setIsSortedRating, setLoading, recentSearches, onSearchRecorded, initialQuery}: any) => {
  const [userInput, setUserInput] = useState("");
  const ranInitial = useRef("");

  const search = (value: string) => {
    const query = value.trim();

    // API requires at least one character
    if (!query) {
      setMsg("Enter a film title to start searching.");
      setResults([]);
      return;
    }

    setLoading(true);
    apiRequest<any>(`/movies/search?q=${encodeURIComponent(query)}`)
      .then((data) => {
        setIsSortedYear(false); // search results initially un-sorted by Year
        setIsSortedRating(false); // search results initially un-sorted by Rating

        // no results returns nothing
        // need empty array to avoid errors
        const newResults = data.items || [];
        if (newResults.length === 0) {
          setMsg("No films found. Try another title.");
          setResults([]);
        }
        if (newResults.length > 0) {
          setMsg(`Results for “${query}”`);
        }
        setResults(newResults);
        onSearchRecorded(query);
        setUserInput("");
      })
      .catch((err) => {
        setMsg("We couldn't load those films. Please try again.");
      })
      .finally(() => setLoading(false));
  };

  // Searches handed over from the home page run straight away.
  useEffect(() => {
    if (initialQuery && ranInitial.current !== initialQuery) { ranInitial.current = initialQuery; search(initialQuery); }
  }, [initialQuery]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = (e: any) => {
    e.preventDefault();
    search(userInput);
  };


  return (
    <div className="title-search">
      <form className="searchbar" onSubmit={onSubmit} role="search">
        <span className="searchbar__icon" aria-hidden="true">⌕</span>
        <input
          type="text"
          name="search"
          placeholder="Search by film title…"
          aria-label="Search by film title"
          className="searchbar__input"
          onChange={(event) => setUserInput(event.target.value)}
          value={userInput}
        />
        <button className="searchbar__submit">Search films <span aria-hidden="true">→</span></button>
      </form>
      {recentSearches.length > 0 && <div className="recent-searches" aria-label="Recent searches"><span>Recent</span><div>{recentSearches.map((query: string) => <button key={query} type="button" onClick={() => { setUserInput(query); search(query); }}><span aria-hidden="true">↗</span> {query}</button>)}</div></div>}
    </div>
  )

}

export default SearchBar;
